import type { OrderDetailsExtended } from 'app/src/model'
import { apiBaseUrl } from 'app/src/msw/shopping/api/apiBaseUrl'
import {
  discountOrdersCollection,
  getAllOrders,
  giftCardsOrdersCollection,
  goodAndServiceOrdersCollection,
  vouchersOrdersCollection,
} from 'app/src/msw/shopping/initialSeed/orders'
import { updateCredit } from 'app/src/msw/shopping/utils/updateCredit'
import { http, HttpResponse } from 'msw'

export const startOrder = http.post<{ orderId: string }, object, undefined>(
  apiBaseUrl + '/orders/:orderId/start',
  async ({ params }) => {
    const order: OrderDetailsExtended = (await getAllOrders()).find((order) => order.orderId === params.orderId)!
    if (order) {
      if (order.product.typology === 'discount') {
        const discountOrder = discountOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
        if (discountOrder) {
          await discountOrdersCollection.update(discountOrder, {
            data(order) {
              order.status = 'confirmed'
            },
          })
        }
      } else if (order.product.typology === 'giftCard') {
        const giftCardOrder = giftCardsOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
        if (giftCardOrder) {
          await giftCardsOrdersCollection.update(giftCardOrder, {
            data(order) {
              order.status = 'confirmed'
              order.purchaseDetails = {
                typology: 'giftCard',
                purchaseDate: new Date().toISOString(),
                expirationDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(), // 1 anno
              }
            },
          })

          try {
            await updateCredit(order)
          } catch (error) {
            console.error('Error starting order:', error)
            return HttpResponse.json(
              {
                status: 409,
                type: 'urn:CreditInsufficient:UserMessage',
                title: "Attenzione, valore fringe benefit non disponibile per procedere con l'operazione",
                rc: 40903,
              },
              { status: 409 },
            )
          }
        }
      } else if (order.product.typology === 'goodAndService') {
        const goodAndServiceOrder = goodAndServiceOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
        if (goodAndServiceOrder) {
          await goodAndServiceOrdersCollection.update(goodAndServiceOrder, {
            data(order) {
              order.status = 'confirmed'
              order.purchaseDetails = {
                typology: 'goodAndService',
                purchaseDate: new Date().toISOString(),
                purchaseDescription: order.product.productName,
                voucherCode: 'a-eedd3c4d-523',
                voucherImageUrl: 'https://placehold.co/400x200?text=GoodAndService+Voucher',
              }
              order.purchaseDetails = {
                typology: 'goodAndService',
                purchaseDate: new Date().toISOString(),
                purchaseDescription: order.product.productName,
                voucherCode: 'a-eedd3c4d-523',
                voucherImageUrl: 'https://placehold.co/400x200?text=GoodAndService+Voucher',
              }
            },
          })

          try {
            await updateCredit(order)
          } catch (error) {
            console.error('Error starting order:', error)
            return HttpResponse.json(
              {
                status: 409,
                type: 'urn:CreditInsufficient:UserMessage',
                title: "Attenzione, valore fringe benefit non disponibile per procedere con l'operazione",
                rc: 40903,
              },
              { status: 409 },
            )
          }
        }
      } else if (order.product.typology === 'voucher') {
        const voucherOrder = vouchersOrdersCollection.findFirst((q) => q.where({ orderId: params.orderId }))
        if (voucherOrder) {
          await vouchersOrdersCollection.update(voucherOrder, {
            data(order) {
              order.status = 'confirmed'
              order.purchaseDetails = {
                typology: 'voucher',
                purchaseDate: new Date().toISOString(),
                expirationDate: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString(),
                voucherCode: 'a-eedd3c4d-523',
                voucherImageUrl: 'https://placehold.co/400x200?text=Voucher',
              }
            },
          })

          try {
            await updateCredit(order)
          } catch (error) {
            console.error('Error starting order:', error)
            return HttpResponse.json(
              {
                status: 409,
                type: 'urn:CreditInsufficient:UserMessage',
                title: "Attenzione, valore fringe benefit non disponibile per procedere con l'operazione",
                rc: 40903,
              },
              { status: 409 },
            )
          }
        }
      }
    }

    return HttpResponse.text(undefined, { status: 204 })
  },
)
